import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { G_TABLE__inputs__base } from '../_base/G_TABLE__inputs__base';
import { HOOK_TABLE_LAYOUT__inputs__token_list } from './HOOK_TABLE_LAYOUT__inputs__token_list';

interface PROPS {
  fields: FIELD__list_token[];
}

export function G_TABLE__inputs__token_list({ fields }: PROPS) {
  const columns = HOOK_TABLE_LAYOUT__inputs__token_list({ fields });

  return <G_TABLE__inputs__base title={'TOKENS LISTS'} fields={fields} columns={columns} />;
}
